import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import FormControl from "@mui/material/FormControl";
import { BaseCheckboxInput } from "../../components/BaseCheckboxInput/BaseCheckboxInput";
export const CheckboxInput = forwardRef(({ onChange, value, ...props }, ref) => {
    return (_jsx(FormControl, { ref: ref, children: _jsx(BaseCheckboxInput, { ...props, checked: value === true, onChange: (e) => onChange?.(e.currentTarget.checked) }) }));
});
//# sourceMappingURL=CheckboxInput.js.map